export default {
  color: "primary",
};
